import {
    createContext, Dispatch, Key, SetStateAction,
} from 'react';

import {IFormValidationErrors} from './report-configuration.types';

export type TTableDatasourceType = 'SQL' | 'TABLE' | 'FUNCTION';

export interface IReportConfigurationContextArgs {
    selectedTabKey: Key | null;
    setSelectedTabKey: Dispatch<SetStateAction<Key>> | null;
    templateCode?: string;
    entityName: string;
    isCreatingNewTemplate: boolean;
    validationErrors: IFormValidationErrors | undefined;
    setValidationErrors: Dispatch<SetStateAction<IFormValidationErrors>> | undefined;
    refetchData: () => void;
}

export const ReportConfigurationContext = createContext<IReportConfigurationContextArgs>({
    selectedTabKey: null,
    setSelectedTabKey: null,
    isCreatingNewTemplate: false,
    entityName: '',
    validationErrors: undefined,
    setValidationErrors: undefined,
    refetchData: () => {},
});
